import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AccountIdentity, RoomId, RoomPid } from "@common/domain";
import { ApiService } from "@youm-front/api/data-access";
import { Observable } from "rxjs";

@Injectable()
export class TelemetryService {
  constructor(private readonly apiService: ApiService) {}

  create(
    roomId: RoomId,
    roomPid: RoomPid,
    accountIdentity: AccountIdentity,
    data: Record<string, unknown>
  ): Observable<void> {
    const formData = new FormData();

    formData.set("roomId", roomId + "");
    formData.set("roomPid", roomPid);
    formData.set("accountIdentity", accountIdentity);
    formData.set("data", JSON.stringify(data));

    return this.apiService.post<void>(
      "telemetry",
      formData,
      "v1",
      new HttpHeaders().set("Content-Type", "multipart/form-data")
    );
  }
}
